import { render, staticRenderFns } from "./ExpiryCarousel.vue?vue&type=template&id=53dcb6dc&scoped=true"
import script from "./ExpiryCarousel.vue?vue&type=script&lang=js"
export * from "./ExpiryCarousel.vue?vue&type=script&lang=js"
import style0 from "./ExpiryCarousel.vue?vue&type=style&index=0&id=53dcb6dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dcb6dc",
  null
  
)

export default component.exports